import React from 'react';
import SidebarUnitDesktop from 'components/sidebar/components/SidebarUnitDesktop';
import { ReceiptEuroIcon } from 'assets/icons';

const PayrollDL = () => {
  return (
    <SidebarUnitDesktop
      routeName="Paie"
      routeSidebar="/payroll/payslips"
      activePatterns={['/payroll']}
      icon={ReceiptEuroIcon}
      text="Paie"
    />
  );
};

export default PayrollDL;
